import { FormBuilderSectionProperty } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent } from 'react'

import { TKeyBuilder } from '../../../infrastructure/internationalisation'
import { FormConfig } from '../../../state/configuration'
import { isInputConfig, isStaticConfig } from '../config'
import { FormBuilderProps } from '../types'
import { useValidationTriggers } from '../validation'
import { FormConditional } from './FormConditional'
import { FormContentDynamic } from './FormContentDynamic'
import { FormContentStatic } from './FormContentStatic'
import { FormReadOnly } from './FormReadOnly'

export interface FormItemProps {
  t: TFunction
  tKey: TKeyBuilder
  config: FormConfig
  prefix?: string
  options?: FormBuilderProps['options']
  variant?: FormBuilderSectionProperty
  errorClassName?: string
}

export const FormItems: FunctionComponent<FormItemProps> = ({
  config,
  t,
  tKey,
  prefix,
  options,
  variant,
  errorClassName,
}) => {
  useValidationTriggers(config)

  return config.map((item, index) => (
    <FormConditional
      key={[item.name, item.type, index].join('-')}
      config={config}
      item={item}
      options={{
        inputValue: {
          prefix,
        },
      }}
    >
      {isStaticConfig(item) ? (
        <FormContentStatic tKey={tKey} t={t} item={item} variant={variant} />
      ) : isInputConfig(item) ? (
        <FormReadOnly tKey={tKey} t={t} item={item} disabled={options?.disableReadOnly}>
          <FormContentDynamic
            tKey={tKey}
            t={t}
            item={item}
            config={config}
            prefix={prefix}
            options={options}
            variant={variant}
            errorClassName={errorClassName}
          />
        </FormReadOnly>
      ) : null}
    </FormConditional>
  ))
}
